// // import { Delete, Edit, Search } from '@mui/icons-material'
// // import { IconButton, Pagination, Paper, Rating, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
// // import React, { useState } from 'react'
// // import { useMutation, useQuery } from 'react-query'
// // import { deleteRatingReviewFn, getRatingReviewFn, patchRatingReviewFn } from '../../Services/RatingReview'
// // import { toast } from 'react-toastify'

// // const RatingReviewManagement = () => {

// //     const [search, setSearch] = useState()
// //     const [page, setPage] = useState()

// //     const { data, refetch } = useQuery(["RatingReview", search, page], () => getRatingReviewFn({ search, page }))
// //     const ReviewData = data?.data?.data

// //     const { mutate: DeleteReview } = useMutation(deleteRatingReviewFn, {

// //         onSuccess: (res) => {

// //             if (res?.data?.response_code === 200) {
// //                 toast.success(res?.data?.msg)
// //                 refetch()
// //             }

// //             else {

// //                 toast.warn(res?.data?.msg)
// //             }
// //         }
// //     })

// //     const { mutate: UpdateReview } = useMutation(patchRatingReviewFn, {

// //         onSuccess: (res) => {

// //             if (res?.data?.response_code === 200) {
// //                 toast.success(res?.data?.msg)
// //                 refetch()
// //             }

// //             else {

// //                 toast.warn(res?.data?.msg)
// //             }
// //         }
// //     })

// //     return (
// //         <>

// //             <div className="p-4 space-y-4">
// //                 {/* Header row */}
// //                 <div className="flex w-full justify-between items-center">
// //                     {/* Search Box */}
// //                     <div className="flex items-center border rounded-md px-2 bg-white">
// //                         <Search className="!text-gray-500" />
// //                         <TextField
// //                             variant="standard"
// //                             placeholder="Search Rating Review"
// //                             value={search}
// //                             onChange={(e) => setSearch(e.target.value)}
// //                             InputProps={{
// //                                 disableUnderline: true,
// //                             }}
// //                             className="!ml-2 !w-72"
// //                         />
// //                     </div>

// //                     {/* Add COD Button */}
// //                     {/* <AddCodManagement
// //                         data={initialValues}
// //                         setInitailValues={setInitailValues}
// //                     /> */}
// //                 </div>

// //                 {/* Table */}
// //                 <div className="item-center form h-[400px] w-full">
// //                     <TableContainer
// //                         component={Paper}
// //                         sx={{ maxHeight: "70vh" }}
// //                         className="!bg-slate-50 !bg-opacity-95 shadow-md rounded-lg"
// //                     >
// //                         <Table stickyHeader aria-label="sticky table" size="small">
// //                             <TableHead>
// //                                 <TableRow>
// //                                     {["SR NO.", "User Name", "Profile Image", "Variant Name", "Rating", "Review Image", "Subject", "Comment", "Action"].map(
// //                                         (head, idx) => (
// //                                             <TableCell
// //                                                 key={idx}
// //                                                 style={{
// //                                                     borderRight: idx !== 3 ? "1px solid #D0D0D0" : "none",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                                 className="!text-center !text-gray-800 !font-bold bg-gray-100"
// //                                             >
// //                                                 {head}
// //                                             </TableCell>
// //                                         )
// //                                     )}
// //                                 </TableRow>
// //                             </TableHead>
// //                             <TableBody>
// //                                 {false ? (
// //                                     <TableRow>
// //                                         <TableCell colSpan={4} className="text-center py-6">
// //                                             Loading Rating Management...
// //                                         </TableCell>
// //                                     </TableRow>
// //                                 ) : ReviewData?.length > 0 ? (
// //                                     ReviewData.map((row, ind) => (
// //                                         <TableRow key={row?.id}>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {ind + 1}
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {row?.user_first_name + " " + row?.user_last_name}
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {row?.profile_picture && <img className='h-10 w-full' src={row?.profile_picture} />}
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {row?.variant_name}
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 <Rating
// //                                                     name="simple-controlled"
// //                                                     value={row?.rate}
// //                                                     readOnly
// //                                                 // onChange={(event, newValue) => {
// //                                                 //     setValue(newValue);
// //                                                 // }}
// //                                                 />
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {row?.review_img && <a href={row?.review_img}   ><img className='h-10 w-full' src={row?.review_img} /></a>}
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {row?.subject}
// //                                             </TableCell>
// //                                             <TableCell
// //                                                 className="!text-center !text-[13px]"
// //                                                 style={{
// //                                                     borderRight: "1px solid #D0D0D0",
// //                                                     fontFamily: "'Poppins', sans-serif",
// //                                                 }}
// //                                             >
// //                                                 {row?.comment}
// //                                             </TableCell>
// //                                             <TableCell className="!text-center !text-[13px]">
// //                                                 <div className="flex items-center justify-center gap-3">
// //                                                     <IconButton
// //                                                         size="small"
// //                                                         color="error"
// //                                                         onClick={() => DeleteReview({ review_id: row?.id })}
// //                                                     >
// //                                                         <Delete fontSize="small" />
// //                                                     </IconButton>
// //                                                     <IconButton
// //                                                         size="small"
// //                                                         color="success"
// //                                                     // onClick={() => setInitailValues(row)}
// //                                                     >
// //                                                         <Switch
// //                                                             checked={row?.active_status === true}
// //                                                             onChange={() =>
// //                                                                 UpdateReview({
// //                                                                     review_id: row?.id,
// //                                                                     active_status: row?.active_status ? "False" : "True",
// //                                                                 })
// //                                                             }
// //                                                         />

// //                                                     </IconButton>
// //                                                 </div>
// //                                             </TableCell>
// //                                         </TableRow>
// //                                     ))
// //                                 ) : (
// //                                     <TableRow>
// //                                         <TableCell colSpan={4} className="text-center py-6">
// //                                             Data  Not found.
// //                                         </TableCell>
// //                                     </TableRow>
// //                                 )}
// //                             </TableBody>
// //                         </Table>
// //                     </TableContainer>

// //                     <div className='flex items-end  justify-end p-4'>

// //                         <Pagination count={data?.data?.total_pages} page={data?.data?.current_page} onChange={(_, value) => setPage(value)} variant="outlined" shape="rounded" />
// //                     </div>
// //                 </div>
// //             </div>
// //         </>
// //     )
// // }

// // export default RatingReviewManagement

// import { Delete, Search } from "@mui/icons-material";
// import {
//   IconButton,
//   Pagination,
//   Paper,
//   Rating,
//   Switch,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
// } from "@mui/material";
// import React, { useState } from "react";
// import { useMutation, useQuery } from "react-query";
// import {
//   deleteRatingReviewFn,
//   getRatingReviewFn,
//   patchRatingReviewFn,
// } from "../../Services/RatingReview";
// import { toast } from "react-toastify";

// const cellSx = {
//   borderRight: "1px solid #D0D0D0",
//   fontFamily: "'Poppins', sans-serif",
//   fontSize: "11px",
//   padding: "3px 8px",
//   textAlign: "center",
//   lineHeight: 1.2,
// };

// const headSx = {
//   ...cellSx,
//   fontWeight: 700,
//   color: "#1f2937",
//   whiteSpace: "nowrap",
//   backgroundColor: "#F3F4F6",
// };

// const RatingReviewManagement = () => {
//   const [search, setSearch] = useState();
//   const [page, setPage] = useState();

//   const { data, refetch } = useQuery(["RatingReview", search, page], () =>
//     getRatingReviewFn({ search, page }),
//   );
//   const ReviewData = data?.data?.data;

//   const { mutate: DeleteReview } = useMutation(deleteRatingReviewFn, {
//     onSuccess: (res) => {
//       if (res?.data?.response_code === 200) {
//         toast.success(res?.data?.msg);
//         refetch();
//       } else {
//         toast.warn(res?.data?.msg);
//       }
//     },
//   });

//   const { mutate: UpdateReview } = useMutation(patchRatingReviewFn, {
//     onSuccess: (res) => {
//       if (res?.data?.response_code === 200) {
//         toast.success(res?.data?.msg);
//         refetch();
//       } else {
//         toast.warn(res?.data?.msg);
//       }
//     },
//   });

//   return (
//     <>
//       <div className="p-2 space-y-2">
//         {/* Header row */}
//         <div className="flex w-full justify-between items-center">
//           {/* Search Box */}
//           <div
//             className="flex items-center border rounded-md px-2 bg-white"
//             style={{ height: 28 }}
//           >
//             <Search sx={{ fontSize: 16 }} className="!text-gray-500" />
//             <TextField
//               variant="standard"
//               placeholder="Search Rating Review"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               InputProps={{
//                 disableUnderline: true,
//                 style: { fontSize: 12 },
//               }}
//               className="!ml-2 !w-56"
//             />
//           </div>

//           {/* Add COD Button */}
//           {/* <AddCodManagement
//                         data={initialValues}
//                         setInitailValues={setInitailValues}
//                     /> */}
//         </div>

//         {/* Table */}
//         <div className="item-center form h-[400px] w-full">
//           <TableContainer
//             component={Paper}
//             sx={{ maxHeight: "74vh" }}
//             className="!bg-slate-50 !bg-opacity-95 shadow-md rounded-lg"
//           >
//             <Table stickyHeader aria-label="sticky table" size="small">
//               <TableHead>
//                 <TableRow>
//                   {[
//                     "SR NO.",
//                     "User Name",
//                     "Profile Image",
//                     "Variant Name",
//                     "Rating",
//                     "Review Image",
//                     "Subject",
//                     "Comment",
//                     "Action",
//                   ].map((head, idx) => (
//                     <TableCell
//                       key={idx}
//                       sx={{
//                         ...headSx,
//                         borderRight: idx !== 8 ? "1px solid #D0D0D0" : "none",
//                       }}
//                     >
//                       {head}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {false ? (
//                   <TableRow>
//                     <TableCell colSpan={9} sx={{ ...cellSx, py: 2 }}>
//                       Loading Rating Management...
//                     </TableCell>
//                   </TableRow>
//                 ) : ReviewData?.length > 0 ? (
//                   ReviewData.map((row, ind) => (
//                     <TableRow key={row?.id} hover>
//                       <TableCell sx={cellSx}>{ind + 1}</TableCell>
//                       <TableCell sx={cellSx}>
//                         {row?.user_first_name + " " + row?.user_last_name}
//                       </TableCell>
//                       <TableCell sx={cellSx}>
//                         {row?.profile_picture && (
//                           <img
//                             alt=""
//                             className="h-6 w-6 mx-auto object-cover"
//                             src={row?.profile_picture}
//                           />
//                         )}
//                       </TableCell>
//                       <TableCell sx={cellSx}>{row?.variant_name}</TableCell>
//                       <TableCell sx={cellSx}>
//                         <Rating
//                           name="simple-controlled"
//                           value={row?.rate}
//                           size="small"
//                           sx={{ fontSize: 14 }}
//                           readOnly
//                           // onChange={(event, newValue) => {
//                           //     setValue(newValue);
//                           // }}
//                         />
//                       </TableCell>
//                       <TableCell sx={cellSx}>
//                         {row?.review_img && (
//                           <a href={row?.review_img}>
//                             <img
//                               alt=""
//                               className="h-6 w-6 mx-auto object-cover"
//                               src={row?.review_img}
//                             />
//                           </a>
//                         )}
//                       </TableCell>
//                       <TableCell sx={cellSx}>{row?.subject}</TableCell>
//                       <TableCell sx={cellSx}>{row?.comment}</TableCell>
//                       <TableCell sx={{ ...cellSx, borderRight: "none" }}>
//                         <div className="flex items-center justify-center gap-1">
//                           <IconButton
//                             size="small"
//                             color="error"
//                             sx={{ p: 0.25 }}
//                             onClick={() => DeleteReview({ review_id: row?.id })}
//                           >
//                             <Delete sx={{ fontSize: 16 }} />
//                           </IconButton>
//                           <IconButton
//                             size="small"
//                             color="success"
//                             sx={{ p: 0.25 }}
//                             // onClick={() => setInitailValues(row)}
//                           >
//                             <Switch
//                               size="small"
//                               checked={row?.active_status === true}
//                               onChange={() =>
//                                 UpdateReview({
//                                   review_id: row?.id,
//                                   active_status: row?.active_status
//                                     ? "False"
//                                     : "True",
//                                 })
//                               }
//                             />
//                           </IconButton>
//                         </div>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={9} sx={{ ...cellSx, py: 2 }}>
//                       Data Not found.
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <div className="flex items-end justify-end px-4 py-2">
//             <Pagination
//               count={data?.data?.total_pages}
//               page={data?.data?.current_page}
//               onChange={(_, value) => setPage(value)}
//               size="small"
//               variant="outlined"
//               shape="rounded"
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default RatingReviewManagement;

import { Delete, Search } from "@mui/icons-material";
import {
  IconButton,
  Pagination,
  Paper,
  Rating,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  deleteRatingReviewFn,
  getRatingReviewFn,
  patchRatingReviewFn,
} from "../../Services/RatingReview";
import { toast } from "react-toastify";

const cellSx = {
  borderRight: "1px solid #D0D0D0",
  fontFamily: "'Poppins', sans-serif",
  fontSize: "11px",
  padding: "3px 8px",
  textAlign: "center",
  lineHeight: 1.2,
};

const headSx = {
  ...cellSx,
  fontWeight: 700,
  color: "#1f2937",
  whiteSpace: "nowrap",
  backgroundColor: "#F3F4F6",
};

const RatingReviewManagement = () => {
  const [search, setSearch] = useState();
  const [page, setPage] = useState();

  const { data, refetch } = useQuery(["RatingReview", search, page], () =>
    getRatingReviewFn({ search, page }),
  );
  const ReviewData = data?.data?.data;

  const { mutate: DeleteReview } = useMutation(deleteRatingReviewFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.msg);
        refetch();
      } else {
        toast.warn(res?.data?.msg);
      }
    },
  });

  const { mutate: UpdateReview } = useMutation(patchRatingReviewFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.msg);
        refetch();
      } else {
        toast.warn(res?.data?.msg);
      }
    },
  });

  return (
    <>
      <div className="p-2 space-y-2">
        {/* Header row */}
        <div className="flex w-full justify-between items-center">
          {/* Search Box */}
          <div
            className="flex items-center border rounded-md px-2 bg-white"
            style={{ height: 28 }}
          >
            <Search sx={{ fontSize: 16 }} className="!text-gray-500" />
            <TextField
              variant="standard"
              placeholder="Search Rating Review"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                disableUnderline: true,
                style: { fontSize: 12 },
              }}
              className="!ml-2 !w-56"
            />
          </div>

          {/* Add COD Button */}
          {/* <AddCodManagement
                        data={initialValues}
                        setInitailValues={setInitailValues}
                    /> */}
        </div>

        {/* Table */}
        <div className="item-center form h-[400px] w-full">
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "74vh" }}
            className="!bg-slate-50 !bg-opacity-95 shadow-md rounded-lg"
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  {[
                    "SR NO.",
                    "User Name",
                    "Profile Image",
                    "Variant Name",
                    "Rating",
                    "Review Image",
                    "Subject",
                    "Comment",
                    "Action",
                  ].map((head, idx) => (
                    <TableCell
                      key={idx}
                      sx={{
                        ...headSx,
                        borderRight: idx !== 8 ? "1px solid #D0D0D0" : "none",
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {false ? (
                  <TableRow>
                    <TableCell colSpan={9} sx={{ ...cellSx, py: 2 }}>
                      Loading Rating Management...
                    </TableCell>
                  </TableRow>
                ) : ReviewData?.length > 0 ? (
                  ReviewData.map((row, ind) => (
                    <TableRow key={row?.id} hover>
                      <TableCell sx={cellSx}>{ind + 1}</TableCell>
                      <TableCell sx={cellSx}>
                        {row?.user_first_name + " " + row?.user_last_name}
                      </TableCell>
                      <TableCell sx={cellSx}>
                        {row?.profile_picture && (
                          <img
                            alt=""
                            className="h-6 w-6 mx-auto object-cover"
                            src={row?.profile_picture}
                          />
                        )}
                      </TableCell>
                      <TableCell sx={cellSx}>{row?.variant_name}</TableCell>
                      <TableCell sx={cellSx}>
                        <Rating
                          name="simple-controlled"
                          value={row?.rate}
                          size="small"
                          sx={{ fontSize: 14 }}
                          readOnly
                          // onChange={(event, newValue) => {
                          //     setValue(newValue);
                          // }}
                        />
                      </TableCell>
                      <TableCell sx={cellSx}>
                        {row?.review_img && (
                          <a href={row?.review_img}>
                            <img
                              alt=""
                              className="h-6 w-6 mx-auto object-cover"
                              src={row?.review_img}
                            />
                          </a>
                        )}
                      </TableCell>
                      <TableCell sx={cellSx}>{row?.subject}</TableCell>
                      <TableCell sx={cellSx}>{row?.comment}</TableCell>
                      <TableCell sx={{ ...cellSx, borderRight: "none" }}>
                        <div className="flex items-center justify-center gap-1">
                          <IconButton
                            size="small"
                            color="error"
                            sx={{ p: 0.25 }}
                            onClick={() => DeleteReview({ review_id: row?.id })}
                          >
                            <Delete sx={{ fontSize: 16 }} />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="success"
                            sx={{ p: 0.25 }}
                            // onClick={() => setInitailValues(row)}
                          >
                            <Switch
                              size="small"
                              checked={row?.active_status === true}
                              onChange={() =>
                                UpdateReview({
                                  review_id: row?.id,
                                  active_status: row?.active_status
                                    ? "False"
                                    : "True",
                                })
                              }
                            />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} sx={{ ...cellSx, py: 2 }}>
                      Data Not found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <div className="flex items-end justify-end px-4 py-2">
            <Pagination
              count={data?.data?.total_pages}
              page={data?.data?.current_page}
              onChange={(_, value) => setPage(value)}
              size="small"
              variant="outlined"
              shape="rounded"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingReviewManagement;
